import KwestGiver from "kwest-giver";
import { decodeJWT, getLocal } from "../utility/functions";

const HamQuest = new KwestGiver(process.env.REACT_APP_API_URL);
HamQuest.showQueueType = true;

const access = getLocal('HSQuestKeys')?.access
if (access) {
    const decoded = decodeJWT(access);
    HamQuest.setLifecycle(decoded.exp * 1000);
}

// Adding requestOrigin to headers
HamQuest.use(config => {
    const { href, origin } = window.location;
    Object.assign(config.headers, { requestOrigin: href.replace(origin, '') })
})

// Adding JWT to headers
HamQuest.use(config => {
    try {
        const keys = getLocal('HSQuestKeys');
        Object.assign(config.headers, { authorization: 'Bearer ' + keys.access })
    } catch {
        console.warn('Keys Missing.')
    }
})

// Adding recaptcha to headers is configured
HamQuest.use(async config => {
    if (config.captcha && window.grecaptcha) {
        try {
            await window.grecaptcha.ready();
            const token = await window.grecaptcha.execute(config.captcha, { action: 'submit' });
            Object.assign(config.headers, { [config.captcha]: token })
        } catch (ex) {
            console.error(ex);
        }
    }
})

// Manipulating the http result data before returning to invoker
HamQuest.use(res => {
    if (res.success === true) {
        return res.resultData;
    }

    if (res.success === false) {
        const errorMessage = {
            error: {
                title: 'Oops',
                errorMessage: res.errorMessage || 'An Error has occurred...',
            },
        };
        throw errorMessage;
    }
}, 'post')

export default HamQuest;